import React from "react";
import WeatherIcon from "./WeatherIcon";
import { getWeatherMeta } from "../services/weatherService";

/**
 * Badge météo affiché à côté de la date dans le planning.
 * Au clic, ouvre le modal avec le détail heure par heure et probabilités de pluie.
 */
export default function WeatherBadge({ dayWeather, isMinimal = false, onClick }) {
  if (!dayWeather) return null;

  const meta = getWeatherMeta(dayWeather.weatherCode);
  const hasRainRisk = dayWeather.maxRainProb >= 15;

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick(dayWeather);
      }}
      className={`inline-flex items-center gap-1 transition-all rounded-full border border-gray-200/90 bg-white/95 hover:bg-white hover:border-indigo-400 hover:shadow-sm group cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400/40 ${
        isMinimal
          ? "px-1 py-0 text-[10px] gap-0.5"
          : "px-1.5 py-0.5 text-xs shadow-[0_1px_2px_rgba(0,0,0,0.04)]"
      }`}
      title={`Météo : ${meta.label} • ${
        dayWeather.minTemp !== null ? `${dayWeather.minTemp}° / ` : ""
      }${dayWeather.maxTemp}°C • Risque de pluie : ${dayWeather.maxRainProb}% • Cliquez pour le détail heure par heure`}
    >
      <WeatherIcon
        code={dayWeather.weatherCode}
        className={`${isMinimal ? "w-3 h-3" : "w-3.5 h-3.5"} transition-transform group-hover:scale-110`}
      />
      
      <span className="font-semibold text-gray-800 group-hover:text-indigo-600 transition-colors">
        {dayWeather.maxTemp !== null ? `${dayWeather.maxTemp}°` : "--"}
      </span>

      {hasRainRisk && (
        <span
          className={`inline-flex items-center text-blue-600 font-medium ${
            isMinimal ? "text-[8px]" : "text-[10px]"
          }`}
        >
          <span className="text-[9px] leading-none">💧</span>
          <span>{dayWeather.maxRainProb}%</span>
        </span>
      )}
    </button>
  );
}
